<template>
  <Layout>
    <div class="section content is-size-7 has-text-white">
      <h1 class="is-size-5 has-text-primary">Kontaktirajte nas</h1>
      <span class="is-size-7">
        <p>
          Ime kompanije:
          778 mobile GmbH<br>
          Adresa:	
          Wiesenstraße 21a2, DE-40549 Düsseldorf – Njemačka,  EU ID: DE303966009<br>
          E-mail podrška: <a class="has-text-primary" href="mailto:gamegame.ba@silverlines.info">gamegame.ba@silverlines.info</a><br>
          
          Telefonska korisnička podrška: <a class="has-text-primary" href="tel:037307900">037307900</a><br>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangGG/BA/Contact.vue